import BaseStyles from './exports/base-styles.js';
export const JHA_THEMES = {
    CONSUMER: 'consumer',
    DESIGN_SYSTEM: 'design-system',
    DESIGN_SYSTEM_INPUTS: 'design-system-inputs',
    JHA_ADMIN: 'jha-admin',
};
const removeOtherStyles = (desiredStyle) => {
    Object.values(JHA_THEMES)
        .filter((id) => id !== desiredStyle)
        .forEach((id) => {
        const styleTag = document.querySelector(`style#jha-wc-${id}`);
        if (styleTag) {
            styleTag.remove();
        }
    });
};
const importDesignSystemInputStyles = async () => {
    const inputStyles = await import(`./exports/design-system-inputs.js`);
    const newTheme = document.createElement('style');
    newTheme.id = 'ds-inputs';
    newTheme.innerHTML = `${inputStyles.default}`;
    document.head.append(newTheme);
};
/**
 * @description: Imports the light and dark themes from jh-core and modifies the dark theme to be
 *  applied using the prefers-color-scheme: dark media query.
 */
const importDesignSystemThemes = async (disableDarkMode = false) => {
    const lightCss = await import('@jack-henry/jh-core/platforms/web/js-css/jh-theme-light.js');
    let style = lightCss.default;
    if (!disableDarkMode) {
        let darkCss = await import('@jack-henry/jh-core/platforms/web/js-css/jh-theme-dark.js');
        darkCss = darkCss.default.replace('.jh-theme-dark', ':root');
        style = `
      ${style}
      @media (prefers-color-scheme: dark) {
        ${darkCss}
      }
    `;
    }
    const themeId = 'jh-theme';
    const jhTheme = document.querySelector(`style#${themeId}`);
    if (jhTheme) {
        jhTheme.innerHTML = style;
    }
    else {
        const newTheme = document.createElement('style');
        newTheme.id = themeId;
        newTheme.innerHTML = style;
        document.head.append(newTheme);
    }
};
const importDesignSystemTheme = async (disableDarkMode = false) => {
    if (disableDarkMode) {
        return import(`./exports/design-system-light-only.js`);
    }
    return import(`./exports/design-system.js`);
};
export const setJhaWcTheme = async (theme, disableDarkMode = false) => {
    let themeStyles;
    try {
        switch (theme) {
            case JHA_THEMES.CONSUMER:
                themeStyles = await import(`./exports/consumer.js`);
                break;
            case JHA_THEMES.DESIGN_SYSTEM:
                await importDesignSystemThemes(disableDarkMode);
                themeStyles = await importDesignSystemTheme(disableDarkMode);
                break;
            case JHA_THEMES.DESIGN_SYSTEM_INPUTS:
                await importDesignSystemThemes(disableDarkMode);
                await importDesignSystemInputStyles();
                themeStyles = await importDesignSystemTheme(disableDarkMode);
                break;
            case JHA_THEMES.JHA_ADMIN:
                themeStyles = await import(`./exports/jha-admin.js`);
                break;
            default:
                break;
        }
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        return;
    }
    const styles = `
    ${BaseStyles}
    ${themeStyles.default}
  `;
    const themeId = `jha-wc-${theme}`;
    const defaultTheme = document.querySelector(`style#${themeId}`);
    if (defaultTheme) {
        defaultTheme.innerHTML = styles;
    }
    else {
        const newTheme = document.createElement('style');
        newTheme.id = themeId;
        newTheme.innerHTML = styles;
        document.head.append(newTheme);
    }
    removeOtherStyles(theme);
};
